<div class="actions">
  <button matButton="tonal" (click)="close()">Cancel</button>
  <button matButton="filled" (click)="confirm()">Confirm</button>
</div>
<app-product-filters-panel [(ngModel)]="data"></app-product-filters-panel>
